import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ValidatorForm from "views/ValidatorForm";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ValidatorForm />} />
        <Route path="/:txhash" element={<ValidatorForm />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
